/**
 * @generated SignedSource<<1bb6172ec6702441813b25cc7fac808c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
export type Type = "PRAISE" | "REQUESTED" | "UNSOLICITED";
import { FragmentRefs } from "relay-runtime";
export type FeedbackListViewer$data = {
  readonly feedbacks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "FeedbackNode";
        readonly context: ReadonlyArray<{
          readonly __typename: "Event";
          readonly end: string | null;
          readonly id: string;
          readonly start: string | null;
          readonly title: string;
        } | {
          readonly __typename: "Note";
          readonly eventEnd: string | null;
          readonly eventStart: string | null;
          readonly id: string;
          readonly title: string;
          readonly url: string | null;
        } | {
          readonly __typename: "OtherContext";
          readonly emoji: string;
          readonly name: string;
        } | {
          readonly __typename: "User";
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
          readonly lastName: string;
          readonly relationshipToViewer: AncestryRelationship | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        }>;
        readonly creator: {
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly lastName: string;
        } | null;
        readonly id: string;
        readonly isAnonymous: boolean;
        readonly isArchived: boolean;
        readonly isDraft: boolean;
        readonly isMeetingFeedback: boolean;
        readonly isThreeSixtyParent: boolean;
        readonly lastSeenByUser: string | null;
        readonly parent: {
          readonly id: string;
        } | null;
        readonly recipients: ReadonlyArray<{
          readonly user: {
            readonly id: string;
          };
        }>;
        readonly requestCount: number;
        readonly requests: ReadonlyArray<{
          readonly user: {
            readonly firstName: string;
            readonly id: string;
          };
        }>;
        readonly responseCount: number;
        readonly sharedWithMe: boolean;
        readonly title: string;
        readonly type: Type;
        readonly updatedAt: string | null;
      } | {
        readonly __typename: "FeedbackRequestNode";
        readonly complete: boolean;
        readonly feedback: {
          readonly context: ReadonlyArray<{
            readonly __typename: "Event";
            readonly end: string | null;
            readonly id: string;
            readonly start: string | null;
            readonly title: string;
          } | {
            readonly __typename: "Note";
            readonly eventEnd: string | null;
            readonly eventStart: string | null;
            readonly id: string;
            readonly title: string;
            readonly url: string | null;
          } | {
            readonly __typename: "OtherContext";
            readonly emoji: string;
            readonly name: string;
          } | {
            readonly __typename: "User";
            readonly email: string;
            readonly firstName: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isGuest: boolean;
            readonly lastName: string;
            readonly relationshipToViewer: AncestryRelationship | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          }>;
          readonly creator: {
            readonly email: string;
            readonly firstName: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly lastName: string;
          } | null;
          readonly id: string;
          readonly isAnonymous: boolean;
          readonly isArchived: boolean;
          readonly isDraft: boolean;
          readonly isMeetingFeedback: boolean;
          readonly isThreeSixtyParent: boolean;
          readonly parent: {
            readonly id: string;
          } | null;
          readonly recipients: ReadonlyArray<{
            readonly user: {
              readonly id: string;
            };
          }>;
          readonly requestCount: number;
          readonly requests: ReadonlyArray<{
            readonly user: {
              readonly firstName: string;
              readonly id: string;
            };
          }>;
          readonly responseCount: number;
          readonly sharedWithMe: boolean;
          readonly title: string;
          readonly type: Type;
          readonly updatedAt: string | null;
        };
        readonly feedbackRecord: {
          readonly id: string;
        } | null;
        readonly hasDraftResponse: boolean;
        readonly id: string;
        readonly isArchived: boolean;
        readonly lastSeenByUser: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
    }>;
  };
  readonly " $fragmentType": "FeedbackListViewer";
};
export type FeedbackListViewer$key = {
  readonly " $data"?: FeedbackListViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackListViewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "feedbacks"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenByUser",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedback",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedWithMe",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isThreeSixtyParent",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAnonymous",
  "storageKey": null
},
v15 = [
  (v3/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackNode",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackRecipientNode",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackRequestNode",
  "kind": "LinkedField",
  "name": "requests",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "context",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationshipToViewer",
          "storageKey": null
        }
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "type": "Note",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emoji",
          "storageKey": null
        }
      ],
      "type": "OtherContext",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aboutUserId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "category"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "feedbackType"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fromUserId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./FeedbackListPaginationQuery.graphql')
    }
  },
  "name": "FeedbackListViewer",
  "selections": [
    {
      "alias": "feedbacks",
      "args": [
        {
          "kind": "Variable",
          "name": "aboutUserId",
          "variableName": "aboutUserId"
        },
        {
          "kind": "Variable",
          "name": "category",
          "variableName": "category"
        },
        {
          "kind": "Variable",
          "name": "feedbackType",
          "variableName": "feedbackType"
        },
        {
          "kind": "Variable",
          "name": "fromUserId",
          "variableName": "fromUserId"
        }
      ],
      "concreteType": "FeedbackAndRequestsConnection",
      "kind": "LinkedField",
      "name": "__FeedbackList_feedbacks_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FeedbackAndRequestsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v16/*: any*/),
                    (v22/*: any*/),
                    (v23/*: any*/),
                    (v24/*: any*/),
                    (v25/*: any*/)
                  ],
                  "type": "FeedbackNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v3/*: any*/),
                    (v12/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasDraftResponse",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "complete",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FeedbackRecordNode",
                      "kind": "LinkedField",
                      "name": "feedbackRecord",
                      "plural": false,
                      "selections": (v15/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FeedbackNode",
                      "kind": "LinkedField",
                      "name": "feedback",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        (v7/*: any*/),
                        (v8/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/),
                        (v11/*: any*/),
                        (v12/*: any*/),
                        (v13/*: any*/),
                        (v14/*: any*/),
                        (v16/*: any*/),
                        (v22/*: any*/),
                        (v23/*: any*/),
                        (v24/*: any*/),
                        (v25/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "FeedbackRequestNode",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "b6023836f4fd02dc4308ccae46485eb4";

export default node;
